import { SearchX } from "lucide-react";
import ProfileCard from "./ProfileCard";

export function GridSkeleton({ n = 8 }) {
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 sm:gap-4 lg:grid-cols-4 lg:gap-5" aria-hidden="true">
      {Array.from({ length: n }).map((_, i) => (
        <div key={i} className="aspect-[3/4] animate-pulse rounded-[12px] border border-lux-border bg-lux-surface" />
      ))}
    </div>
  );
}

export default function ResultsGrid({ cards, loading, onClear, showCity = false, emptyTitle = "No advertisers match these filters", emptyText = "Try removing a filter or browsing a nearby area." }) {
  if (loading) return <GridSkeleton />;
  if (!cards?.length) {
    return (
      <div className="lux-card flex flex-col items-center px-6 py-16 text-center" data-testid="results-empty">
        <SearchX className="h-8 w-8 text-lux-silver" aria-hidden="true" />
        <h3 className="mt-4 font-serif text-2xl">{emptyTitle}</h3>
        <p className="mt-2 max-w-sm text-sm text-lux-muted">{emptyText}</p>
        {onClear && <button onClick={onClear} className="lux-btn lux-btn-secondary mt-6" data-testid="results-empty-clear">Clear filters</button>}
      </div>
    );
  }
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 sm:gap-4 lg:grid-cols-4 lg:gap-5" data-testid="results-grid">
      {cards.map((c, i) => <ProfileCard key={c.slug} card={c} index={i} showCity={showCity} />)}
    </div>
  );
}

export function ErrorState({ title = "Something went wrong", text = "Please try again in a moment." }) {
  return (
    <div className="mx-auto max-w-xl px-4 py-24 text-center" data-testid="error-state">
      <h1 className="font-serif text-4xl">{title}</h1>
      <p className="mt-3 text-lux-muted">{text}</p>
    </div>
  );
}
